import store from '../../store'
import {
    DEVICES_SET_DATA,
    DEVICES_SET_DEVICE_WRITER_DATA,
    DEVICES_SET_MARKERS,
    DEVICES_SET_SERVICE_HISTORY,
} from '../devices'
import type { Device } from '../../types/domain'
import {
    parseSingleMarker,
    MapMarker,
} from '../../components/shared/map'
import {
    ACTIVE_LOW_OIL_ALARM,
    OIL_LEVEL,
    VOLTAGE,
} from '../../components/shared/device-addresses'

interface DeviceEnriched extends Device {
    marker: MapMarker & { href: string }
    oilLevelPercentage: number | string
    voltage: number
    oilAlarm: boolean
}

interface DeviceWriterItem {
    dbAddress: string
    [key: string]: unknown
}

/**
 * Set devices data into store
 *
 * @param setInStore - store data into redux?
 */
export const setDevicesData = (data: Device[], setInStore = true): DeviceEnriched[] => {
    const dataToSave: DeviceEnriched[] = [...data]
        .sort((aItem, bItem) => {
            const locationIPA = (aItem.name ?? '').toLowerCase()
            const locationIPB = (bItem.name ?? '').toLowerCase()
            if (locationIPA < locationIPB) {
                return -1
            }
            if (locationIPA > locationIPB) {
                return 1
            }

            return 0
        })
        .sort((aItem, bItem) => {
            const locationIPA = aItem.locationIP ?? ''
            const locationIPB = bItem.locationIP ?? ''
            if (locationIPA < locationIPB) {
                return -1
            }
            if (locationIPA > locationIPB) {
                return 1
            }

            return 0
        })
        .map(dataItem => {
            const { latitude: rawLat, longitude: rawLng, ...restDataItem } = dataItem
            const latitude = rawLat !== undefined ? Number(rawLat) : undefined
            const longitude = rawLng !== undefined ? Number(rawLng) : undefined

            return {
                ...restDataItem,
                latitude,
                longitude,
                marker: {
                    ...parseSingleMarker(
                        { latitude: rawLat ?? 0, longitude: rawLng ?? 0 },
                        dataItem.uid ?? '',
                    ),
                    href: `/devices/${dataItem.uid}`,
                },
                oilLevelPercentage: (dataItem?.readData?.find?.(deviceData => deviceData.hint === OIL_LEVEL)?.data as number | string) ?? 0,
                voltage: (dataItem?.readData?.find?.(deviceData => deviceData.hint === VOLTAGE)?.data as number) / 1000,
                oilAlarm: parseInt(
                    String(dataItem?.readData?.find?.(deviceData => deviceData.hint === ACTIVE_LOW_OIL_ALARM)?.data),
                    10,
                ) !== 0,
            }
        })

    if (setInStore) {
        store.dispatch({
            type: DEVICES_SET_MARKERS,
            data: dataToSave.map(dataItem => dataItem.marker),
        })

        store.dispatch({
            type: DEVICES_SET_DATA,
            data: dataToSave,
        })
    }

    return dataToSave
}

/**
 * Set device data writer addresses into store
 */
export const setDeviceWriterDataAction = (data: DeviceWriterItem[]): void => {
    store.dispatch({
        type: DEVICES_SET_DEVICE_WRITER_DATA,
        data: data.map(dataItem => dataItem.dbAddress),
    })
}

/**
 * Hover | un-hover marker
 */
export const toggleHoverMarker = (markerUid: string, hovered: boolean): void => {
    const markers: MapMarker[] = [...(store.getState()?.devices?.markers || [])]

    const markerIndex = markers?.findIndex(marker => marker?.id === markerUid)

    if (markerIndex !== -1) {
        markers[markerIndex].isHovered = hovered
    }

    store.dispatch({
        type: DEVICES_SET_MARKERS,
        data: markers,
    })
}

/**
 * Set device service history action
 */
export const setDeviceServiceHistoryAction = (data: unknown[]): void => {
    store.dispatch({
        type: DEVICES_SET_SERVICE_HISTORY,
        data: data,
    })
}
